<template>
  <div>
    <main-table-layout
        :id="$route.params.id"
        back-button-tab-selector="organizationbackbutton"
        sub-menu-selector="adminpanel"
        tab-selector="organizationtab"
        type="organization"
        :has-top-bar="false"
    >
      <div slot="mainContent" class="row">
        <div class="col-12">
          <h1>{{ $t('Dashboard') }} {{ $store.getters.getOrganizationById($route.params.id).displayName }}</h1>
        </div>
        <div v-if="$store.getters.isSuperAdmin || $store.getters.isSFXMember" class="col-12">
          <meta-panel
              v-if="metaSet && ($store.getters.isSFXMember || $store.getters.isSuperAdmin)"
              :key="metaSet.id"
              :fields="metaSet.metaFields" :organization-ids="[$route.params.id]" :title="metaSet.description"
              icon-left="folder"
              store-name="Organization"
              @updated="init"
          />
        </div>

        <div class="col-12 col-sm-6 col-xl-3 mb-2">
          <div class="dashboard-panel border-radius">
            <components-panel
                :organization-id="$route.params.id"
                :auto-load="true"
                :node-model-assets-limit="nodeModelAssetsLimit"
              />
          </div>
        </div>

        <div class="col-12 col-sm-6 mb-1">
          <div class="dashboard-panel break-word border-radius">
          <user-panel
              v-if="orgUsers"
            :organization-id="$route.params.id"
            :org-users="orgUsers"
            :auto-load="true"
          />
          </div>
        </div>

        <!--VM USAGE-->
        <div class="col-12 col-sm-6 col-xl-3">
          <div class="dashboard-panel border-radius">
            <vm-usage-panel
              :organization-id="$route.params.id"
              :auto-load="true"
            />
          </div>
        </div>

        <div class="col-12 mt-5 pt-3">
          <h2>{{ $t('CurrentItems') }}</h2>
        </div>

        <div class="col-12 col-sm-6 col-xl-3 mb-2">
          <div class="dashboard-panel border-radius">
            <div class="row">
              <div class="col-12">
                <h3>{{ $t('NewestAssemblies') }}</h3>
                <div v-for="(a, assindex) in assemblies" :key="a.id + assembliesReRenderKey" class="mb-2 bg-darker p-2 border-radius">
                  <div class="lighter date-item">{{ dateFromISO(a.createdAt) }}</div>
                  <div class="mb-1"><router-link :to="'/library/3d-data/assembly/' + a.id + '/general'">{{ a.name }}</router-link></div>
                  <div class="lighter" v-if="a.assets">{{ $t('dashboard.uniqueParts') }}: {{ a.assets }}</div>
                  <div class="lighter" v-if="a.instances">{{ $t('dashboard.totalParts') }}: {{ a.instances }}</div>
                  <!--<div class="lighter" v-if="a.instances && a.assets">{{ $t('dashboard.totalRelevantParts') }}: {{ calculateFactor(a.instances, a.assets) }}</div>-->
                  <div v-else
                       class="settings-button d-inline-block switched-colors mt-1" @click="loadProjectInstances(assindex, a.sourceProjectId, a.id)">
                    {{ $t('LoadAmountOfParts') }}
                    <loading-spinner v-if="isLoading === a.id" class="ml-1"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-3 mb-2">
          <div class="dashboard-panel border-radius">
            <div class="row">
              <div class="col-12">
                <h3>{{ $t('NewestProjects') }}</h3>
                <div v-for="a in projects" :key="a.id" class="mb-2">
                  <div class="lighter date-item">{{ dateFromISO(a.createdAt) }}</div>
                  <router-link :to="'/project/' + a.id + '/general'">{{ a.name }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--STORAGE-->
        <div v-if="$store.getters.isSuperAdmin && false" class="col-3">
          <div class="dashboard-panel border-radius">
            <h3>{{ $t('Storage') }}</h3>
            <span class="lighter">Your storage limit</span><br/>
            <b>{{ getReadableFileSize(storageLimit) }}</b><br/>
            <span v-if="storage" class="lighter">Used storage</span>
            <h3>{{ storage }}</h3>
            <loading-spinner v-if="loadingStorageUsage"/>
            <canvas :id="storageChartId" height="200" width="400"></canvas>
          </div>
        </div>


        <!--<div class="col-3">
          <div class="dashboard-panel border-radius">
            <h3>{{ $t('MediaAssets') }}</h3>
            <span class="lighter">{{ $t('yourMediaAssets') }}</span><br/>
            <h3>{{ mediaAssets }}</h3>
            <loading-spinner v-if="loadingMediaAssets"/>
          </div>
        </div>--->


      </div>
    </main-table-layout>
  </div>
</template>

<script>
import MainTableLayout from "../layouts/MainTableLayout.vue";
import LoadingSpinner from "../components/LoadingSpinner";
import filesize from "file-size";
import {SpecialUuids} from "@/enum";
import MetaPanel from "../components/widgets/meta/MetaPanel";
import DateMixin from "@/components/mixins/DateMixin.js";
import UserPanel from "@/components/organizationDashboard/UserPanel.vue";
import VmUsagePanel from "@/components/organizationDashboard/VmUsagePanel.vue";
import ComponentsPanel from "@/components/organizationDashboard/ComponentsPanel.vue";
import {initChart} from "@/components/organizationDashboard/ChartHelper";
export default {
  name: "OrganizationDashboard",
  components: {
    MainTableLayout,
    LoadingSpinner,
    MetaPanel,
    UserPanel,
    VmUsagePanel,
    ComponentsPanel
  },
  mixins: [DateMixin],
  data() {
    return {
      isLoading: null,
      assembliesReRenderKey: 0,
      SpecialUuids: SpecialUuids,

      // storage
      loadingStorageUsage: false,
      storage: 0,
      storageLimit: 30000000000,
      storageChartId: null,
      storageChart: null,

      userChartId: null,
      userChart: null,

      userChartId2: null,
      userChart2: null,

      logs: null,

      // 3d assets
      nodeModelChartId: null,
      nodeModelAssetsLimit: 100000,
      nodeModelChart: null,

      // media
      loadingMediaAssets: false,
      mediaChartId: null,
      mediaAssets: null,
      mediaAssetsLimit: 100000,

      // 3d instances
      instanceChartId: null,
      instancesLimit: 1000,
      instances: null,
      totalInstances: null,
      instanceChart: null,

      metaSet: null,

      assemblies: [],
      projects: [],

      organization: {},
      orgUsers: []
    };
  },
  beforeMount() {
    this.storageChartId = Math.random().toString(36).substring(2, 7);
    this.nodeModelChartId = Math.random().toString(36).substring(2, 7);
    this.mediaChartId = Math.random().toString(36).substring(2, 7);
    this.instanceChartId = Math.random().toString(36).substring(2, 7);
    this.userChartId = Math.random().toString(36).substring(2, 7);
    this.userChartId2 = Math.random().toString(36).substring(2, 7);

  },
  mounted() {
    //this.loadVMLogs(); // the summary is enough for now
    this.init();
  },
  methods: {
    initChart,
    async init() {
      await this.loadMetaSet();
      this.loadAssemblies();
      this.loadProjects();
    },
    calculateFactor(instances, assets) {
      // this formula calculates
      const calculated = (assets * 2) + (instances ? instances : 0);
      return (calculated / 3).toFixed(0);
    },
    async loadMetaSet() {
      await this.$store.dispatch('loadOrganization', {
        id: this.$route.params.id,
        include: 'metaSets'
      }).then(async data => {
        await this.$store.dispatch('clientLoadOrganizationUsers', {
          id: this.$route.params.id
        }).then(orgUsers => {
          this.orgUsers = orgUsers;
        })
        this.organization = data;
        const metaSets = data.metaSets;
        this.metaSet = metaSets.filter(item => {
          return item.id === this.SpecialUuids['LICENCE_METASET']
        })[0];
        const storageLimit = this.metaSet.metaFields.filter(item => {
          return item.id === SpecialUuids.STORAGE_LIMIT_METAFIELD
        });
        if (storageLimit[0]) {
          const st = storageLimit[0];
          this.storageLimit = this.getValue(st, true);
        }
        const sfxAssetLimit = this.metaSet.metaFields.filter(item => {
          return item.id === SpecialUuids.ASSET_LIMIT_METAFIELD
        });
        if (sfxAssetLimit[0]) {
          const st = sfxAssetLimit[0];
          this.nodeModelAssetsLimit = this.getValue(st, true);
        }

        const viewerLimit = this.metaSet.metaFields.filter(item => {
          return item.id === SpecialUuids.VIEWER_LIMIT_METAFIELD
        });
        if (viewerLimit[0]) {
          const st = viewerLimit[0];
          this.viewerLimit = this.getValue(st, true);
        }

        const editorLimit = this.metaSet.metaFields.filter(item => {
          return item.id === SpecialUuids.EDITOR_LIMIT_METAFIELD
        });
        if (editorLimit[0]) {
          const st = editorLimit[0];
          this.editorLimit = this.getValue(st, true);
        }
      });
    },
    getValue(st, doParseInt = false) {
      if (doParseInt) {
        return st.metaValues && st.metaValues.length ? parseInt(st.metaValues[0].value) : parseInt(st.defaultValue);
      }
      return st.metaValues && st.metaValues.length ? parseInt(st.metaValues[0].value) : parseInt(st.defaultValue);
    },
    async loadProjectInstances(index, projectId, assemblyId) {
      this.isLoading = assemblyId;
      return await this.$store.dispatch('clientLoadProjectInstances', {
        id: projectId,
        fields: ['id', 'assetId'],
        limit: 0
      }).then(items => {
        const uniqueAssets = [];
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (!uniqueAssets.includes(item.assetId)) {
            uniqueAssets.push(item.assetId)
          }
        }
        this.assemblies[index].assets = uniqueAssets ? uniqueAssets.length : 'N/A';
        this.assemblies[index].instances = items ? items.length : 'N/A';
        this.isLoading = null;
        this.assembliesReRenderKey++;
      })
    },
    async loadAssemblies() {
      return await this.$store.dispatch('clientLoadAssets', {
        filter: 'type eq assembly,organizationId eq ' + this.$route.params.id,
        sort: '-createdAt',
        //limit: 6,
      }).then(data => {
        this.assemblies = data;
      })
    },
    async loadProjects() {
      return await this.$store.dispatch('clientLoadProjects', {
        filter: 'type eq vstage,organizationId eq ' + this.$route.params.id,
        sorting: '-createdAt',
        limit: 6,
      }).then(data => {
        if(!data || !data.length) {
          this.projects = [];
          return;
        }
        this.projects = data.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
      })
    },
    getReadableFileSize(num) {
      return filesize(num, {fixed: 2, spacer: ' '}).human('si');
    },
  }
}
</script>

<style lang="scss">
.panel-hr {
  border: 0;
  height: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(255,255,255,0.2);
}
</style>

<style lang="scss" scoped>
.dashboard-panel {
  background-color: var(--vform-editor-ui-secondary-color);
  padding: 15px;
}

.vform-label {
  color: #fff !important;
}

.date-item {
  margin-bottom: -4px;
  font-size: 0.8rem;
}

.break-word {
  word-wrap: break-word;
}

.small-font {
  font-size: 0.8rem;
}
.bg-darker {
  background-color: rgba(0,0,0,0.2);
}
</style>
